<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>库存</el-breadcrumb-item>
      <el-breadcrumb-item>库存状态</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :inline="true"
          :model="formQuery"
          ref="formQuery"
          label-width="70px"
          label-position="left"
        >
          <el-form-item label="产品名称" prop="query">
            <el-input size="small" autocomplete="off" v-model="formQuery.query"></el-input>
          </el-form-item>
          <el-form-item label="仓库" prop="stockroom_id">
            <el-select v-model="formQuery.stockroom_id" filterable placeholder="请选择" size="small">
              <el-option
                v-for="item in stockrooms"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类别" prop="item_category_id">
            <el-select
              v-model="formQuery.item_category_id"
              filterable
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in cates"
                :key="item.id"
                :label="item.whole_name.replace(/,/g, ' - ')"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="对象" prop="category">
            <el-select v-model="formQuery.category" placeholder="请选择" size="small">
              <el-option key="0" label="所有" :value="0"></el-option>
              <el-option key="1" label="零件" :value="1"></el-option>
              <el-option key="2" label="设备" :value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="入库时间" prop="dates">
            <el-date-picker
              v-model="formQuery.dates"
              size="small"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button size="small" type="primary" @click="initData">筛选</el-button>
          <el-button size="small" @click="resetForm('formQuery')">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-table v-loading="loading" :data="lists" stripe header-row-class-name="q-products-header">
        <el-table-column label="对象">
          <template slot-scope="scope">{{scope.row.item.category == 1 ? '零件' : '设备'}}</template>
        </el-table-column>
        <el-table-column prop="item_category.name" label="类别" min-width="200" align="center">
          <template slot-scope="scope">{{scope.row.item_category.whole_name.replace(/,/g, " - ")}}</template>
        </el-table-column>
        <el-table-column prop="item.name" label="产品名称 - 件号" min-width="260px" align="left">
          <template slot-scope="scope">{{scope.row.item.name}} - {{scope.row.item.part_number}}</template>
        </el-table-column>
        <el-table-column prop="item.price" label="定价" align="center"></el-table-column>
        <!-- <el-table-column prop="stock_in_bill.code_number" label="采购单号"></el-table-column> -->
        <el-table-column prop="price" label="进货价" align="center">
          <template slot-scope="scope">{{scope.row.price.toFixed(2)}}</template>
        </el-table-column>
        <el-table-column prop="stockroom.name" label="仓库" align="center"></el-table-column>
        <el-table-column prop="store_number" label="库存量" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              @click="showStoreItemDetail(scope.row.id)"
            >出库记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :current-page.sync="page"
        @current-change="handlePageChange"
        layout="total, prev, pager, next"
        :page-size="size"
        :total="total"
      ></el-pagination>
    </div>
    <detail :model="model" :show.sync="detailDialog"></detail>
  </div>
</template>

<script>
import Detail from '@/views/store/_store_item_out_detail'
import {
  stockItemList,
  itemCategoryList,
  stockroomList
} from '@/service/getData'
import { clone } from '@/util'

export default {
  components: {
    Detail
  },
  data() {
    return {
      formQuery: {
        query: '',
        item_category_id: '',
        category: 0,
        stockroom_id: '',
        dates: ''
      },
      model: {},
      detailDialog: false,
      loading: true,
      page: 1,
      size: 30,
      total: 0,
      lists: [],
      cates: [],
      stockrooms: []
    }
  },
  created() {
    this.initData()
    this.getItemCategoryList()
    this.getStockroomList()
  },
  methods: {
    async initData() {
      let params = clone(this.formQuery)
      params.page = this.page - 1
      params.size = this.size

      let dates = this.formQuery.dates
      if (dates && dates.length == 2) {
        params.start_time = dates[0] || ''
        params.end_time = dates[1] || ''
      }

      let res = await stockItemList(params)
      this.lists = res.data.list
      this.total = res.data.total
      this.loading = false
    },

    async getItemCategoryList() {
      let res = await itemCategoryList({ page: 0, size: 1000 })
      if (res.code == 0) {
        this.cates = res.data.list
      }
    },

    async getStockroomList() {
      let res = await stockroomList({ page: 0, size: 1000 })
      if (res.code == 0) {
        this.stockrooms = res.data.list
      }
    },

    showStoreItemDetail(id) {
      this.detailDialog = true
      this.model = {
        id: id
      }
    },

    handlePageChange(e) {
      this.page = e
      this.loading = true
      this.initData()
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page = 1
      this.initData()
    }
  }
}
</script>
